import React from "react";
import { Theme, makeStyles, createStyles, AppBar, Toolbar } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { addMonths, format } from 'date-fns';
import DateFnsUtils from "@date-io/date-fns";
import { CalendarIcon } from "../../../assets/iconComponents/Icons";
import { KeyboardDatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import YellowBox from "./YellowBox";

const useStylesSubHeader = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1
        },
        menuButton: {
            marginLeft: theme.spacing(1)
        },
        centerText: {
            color: "#FFF",
            fontSize: 18,
            fontWeight: 700,
            opacity: 0.36,
            textTransform: "none"
        },
        datePickerRoot: {
            width: 176,
            padding: "7px 0px",
            height: 38,
        },
        datePickerIcon: {
            backgroundColor: "#02489D",
            borderRadius: 4,
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
            padding: 6,
            '&:hover': {
                backgroundColor: '#02489D7F'
            },
        }
    })
);


const CustomDateHeader = ({ setStartDateMain, setEndDateMain }: any): JSX.Element => {

    const classes = useStylesSubHeader();

    const [startDate, setStartDate] = React.useState<Date>(addMonths(new Date(), -1));
    const [endDate, setEndDate] = React.useState<Date>(new Date());

    const handleStartDateChange = (date: Date | null) => {
        setStartDate(date || new Date());
    };

    const handleEndDateChange = (date: Date | null) => {
        setEndDate(date || new Date());
    };

    return (
        <div className={classes.root}>
            <AppBar position="static" style={{ backgroundColor: "#000D1D" }}>
                <Toolbar variant="regular" style={{ height: 72 }} >
                    <span
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center"
                        }}
                    >
                        <Typography
                            className={classes.centerText}
                            style={{ opacity: 1, marginRight: "19px" }}
                        >
                            From
                        </Typography>
                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                            <KeyboardDatePicker
                                margin="normal"
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                value={startDate}
                                onChange={handleStartDateChange}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                    classes: {
                                        root: classes.datePickerIcon
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        root: classes.datePickerRoot
                                    }
                                }}
                                style={{ margin: 0 }}
                                keyboardIcon={<CalendarIcon fontSize="small" />}
                            />
                        </MuiPickersUtilsProvider>

                        <Typography
                            className={classes.centerText}
                            style={{ opacity: 1, marginLeft: "45px", marginRight: "16px" }}
                        >
                            To
                        </Typography>
                        <MuiPickersUtilsProvider utils={DateFnsUtils}>
                            <KeyboardDatePicker
                                margin="normal"
                                inputVariant="outlined"
                                format="dd/MM/yyyy"
                                value={endDate}
                                onChange={handleEndDateChange}
                                KeyboardButtonProps={{
                                    "aria-label": "change date",
                                    classes: {
                                        root: classes.datePickerIcon
                                    }
                                }}
                                InputProps={{
                                    classes: {
                                        root: classes.datePickerRoot
                                    }
                                }}
                                style={{ margin: 0 }}
                                keyboardIcon={<CalendarIcon fontSize="small" />}
                            />
                        </MuiPickersUtilsProvider>

                        <Button style={{ minWidth: 57, padding: 0, marginLeft: "37px" }} >
                            < YellowBox title="Go" onClick={() => {
                                setStartDateMain(format(startDate, "yyyy-MM-dd"));
                                setEndDateMain(format(endDate, "yyyy-MM-dd"));
                            }} style={{ padding: "7px 16px" }} />
                        </Button>
                    </span>

                </Toolbar>
            </AppBar>
        </div>
    );
}

export default CustomDateHeader;